<template>
  <div
    class="month-event"
    :style="defaultStyle"
  >
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column">
        <span class="name">{{ userRealName }}</span>
        <span class="event-details">{{ eventDetails }} </span>
      </div>

      <div
        v-if="shiftSpillover"
        class="d-flex align-items-center"
      >
        <i
          v-tooltip="{ placement: 'top' }"
          class="hi-right"
          title="This shift continues into the next day"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SchedulesEventMixin from '~/mixins/attendance_schedules/SchedulesEventMixin';
import tooltipDirective from '~/directives/tooltip';

// Rendered inside @fullcalendar/vue3's mini `createApp`, which doesn't inherit the host app's
// context — no `$page` (mapInertiaProps would crash) and no global directives. `timeZone` comes in
// as a prop from the host and the tooltip directive is registered locally.
export default {
  name: 'MonthViewEvent',
  directives: { tooltip: tooltipDirective },
  mixins: [SchedulesEventMixin],
  props: {
    event: {
      type: Object,
      required: true,
    },
    timeZone: {
      type: String,
      default: '',
    },
  },
  computed: {
    eventDetails() {
      return this.type !== 'Holiday' ? `${this.type}: ${this.duration}` : this.type;
    },
  },
};
</script>
